{
    "env": "dev",
    "file": "latencydata.20260907.csv",
    "label": "Aug 25 - Aug 26",
    "metric": "latency",
    "data": [
        {
            "latencybucket": 2,
            "frequency": 0.0091
        },
        {
            "latencybucket": 2.25,
            "frequency": 0.0961
        },
        {
            "latencybucket": 2.5,
            "frequency": 0.2177
        },
        {   
            "latencybucket": 2.75,
            "frequency": 0.2657
        },
        {
            "latencybucket": 3,
            "frequency": 0.2193
        },
        {
            "latencybucket": 3.25,
            "frequency": 0.1303
        },
        {
            "latencybucket": 3.5,
            "frequency": 0.0424
        },
        {
            "latencybucket": 3.75,
            "frequency": 0.008
        },
        {
            "latencybucket": 4,
            "frequency": 0.0021
        },
        {
            "latencybucket": 4.25,
            "frequency": 0.0011
        },
        {
            "latencybucket": 4.5,
            "frequency": 0.0007
        },
        {
            "latencybucket": 4.75,
            "frequency": 0.0005
        },
        {
            "latencybucket": 5,
            "frequency": 0.0004
        },
        {
            "latencybucket": 5.25,
            "frequency": 0.0004
        },
        {
            "latencybucket": 5.5,
            "frequency": 0.0004
        },
        {
            "latencybucket": 5.75,
            "frequency": 0.0003
        },
        {
            "latencybucket": 6,
            "frequency": 0.0002
        },
        {
            "latencybucket": 6.25,
            "frequency": 0.0002
        },
        {
            "latencybucket": 6.5,
            "frequency": 0.0002
        },
        {
            "latencybucket": 6.75,
            "frequency": 0.0001
        },
        {
            "latencybucket": 7,
            "frequency": 0.0001
        },
        {
            "latencybucket": 7.25,
            "frequency": 0.0001
        },
        {
            "latencybucket": 7.5,
            "frequency": 0.0001
        },
        {
            "latencybucket": 7.75,
            "frequency": 0.0001
        },
        {
            "latencybucket": 8,
            "frequency": 0.0001
        },
        {
            "latencybucket": 8.25,
            "frequency": 0
        },
        {
            "latencybucket": 8.5,
            "frequency": 0
        },
        {
            "latencybucket": 8.75,
            "frequency": 0
        },
        {
            "latencybucket": 9,
            "frequency": 0
        },
        {
            "latencybucket": 9.25,
            "frequency": 0
        },
        {
            "latencybucket": 9.5,
            "frequency": 0
        },
        {
            "latencybucket": 9.75,
            "frequency": 0
        },
        {
            "latencybucket": 10,
            "frequency": 0
        },
        {
            "latencybucket": 10.25,
            "frequency": 0
        },
        {
            "latencybucket": 10.5,
            "frequency": 0
        },
        {
            "latencybucket": 10.75,
            "frequency": 0
        },
        {
            "latencybucket": 11,
            "frequency": 0
        },
        {
            "latencybucket": 11.25,
            "frequency": 0
        },
        {
            "latencybucket": 11.75,
            "frequency": 0
        },
        {
            "latencybucket": 12,
            "frequency": 0
        },
        {
            "latencybucket": 12.25,
            "frequency": 0
        },
        {
            "latencybucket": 12.5,
            "frequency": 0
        },
        {
            "latencybucket": 12.75,
            "frequency": 0
        },
        {
            "latencybucket": 13,
            "frequency": 0
        },
        {
            "latencybucket": 13.75,
            "frequency": 0
        },
        {
            "latencybucket": 14,
            "frequency": 0
        },
        {
            "latencybucket": 14.25,
            "frequency": 0
        },
        {
            "latencybucket": 14.5,
            "frequency": 0
        },
        {
            "latencybucket": 14.75,
            "frequency": 0
        },
        {
            "latencybucket": 15.75,
            "frequency": 0
        },
        {
            "latencybucket": 16,
            "frequency": 0
        },
        {
            "latencybucket": 16.5,
            "frequency": 0
        },
        {
            "latencybucket": 16.75,
            "frequency": 0
        },
        {
            "latencybucket": 17.25,
            "frequency": 0
        },
        {
            "latencybucket": 18.5,
            "frequency": 0
        },
        {
            "latencybucket": 18.75,
            "frequency": 0
        },
        {
            "latencybucket": 19.5,
            "frequency": 0
        },
        {
            "latencybucket": 20.25,
            "frequency": 0
        }
    ]
}